
import { defineComponent, PropType } from 'vue'
import moment from 'moment'

// types
import { DispatcherOrderStatusT } from '@/core/types/dispatcher.types'

export default defineComponent({
    props: {
        statuses: {
            type: Array as PropType<DispatcherOrderStatusT[]>,
            default: null,
        },
    },
    setup() {
        return { moment }
    },
})
